module.exports = __webpack_public_path__ + "img/vector_maya_01.acc04590.svg";